import { assetsDashboardsListEntryPoint as assetsDashboardsListEntryPointSpa } from '@jira/spa-apps__servicedesk-cmdb-assets-dashboards/src/assetsDashboardsListEntryPoint.entrypoint.tsx';
import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { assetsDashboardsSemanticModelResource } from '@jira/router-resources__viz-platform/src/assetsDashboardsSemanticModelResource.tsx';
import { assetsDashboardsRoute } from '@jira/router-routes__assets-app-routes/src/assetsDashboardsRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsDashboardsListPageEntryPoint = createChromelessEntryPoint({
	main: assetsDashboardsListEntryPointSpa,
});

export const assetsDashboardsRouteEntry: Route = createEntry(assetsDashboardsRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	entryPoint: () => assetsDashboardsListPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-dashboards-list-page',
	resources: [
		...getAssetsAppResources(),
		...getServicedeskPageContextResources(),
		resourceWithCondition(
			() => fg('platform_avp_enable_jsm_assets_metrics'),
			assetsDashboardsSemanticModelResource,
		),
	],
	forPaint: [LazyAssetsLayout],
	meta: {
		reporting: {
			id: APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE,
			packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_DASHBOARDS_LIST_PAGE),
			teamName: 'ITSM SAGA',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
